import { enGB, fr } from "date-fns/locale";

export function getLocale() {
    return { fr, en: enGB }[(localStorage.getItem("side_team_locale") || "fr") as "fr" | "en"];
}
